import React from 'react';
import { ThemeDesigner } from './ThemeDesigner';
import { Modal, Button, Form } from 'react-bootstrap';
import Loader from '../loader';
import { saveThemes } from '../../services/publishData';
import { addNotification } from '../../action/notificationAction';

export default class ThemeDesignerModal extends React.Component {
    constructor(props) {
        super(props);
    }
    componentWillMount() {
        this.resetState();
    }
    resetState = () => this.setState({
        isLoading: false,
        theme: { name: "", themeJson: "" },
        companyId: undefined
    });
    componentWillReceiveProps(nextProps) {
        if (this.state.companyId === undefined || this.state.companyId !== nextProps.selectedCompanyID) {
            this.setState({ companyId: nextProps.selectedCompanyID });
        }
    }
    onHandleClose = () => {
        this.resetState();
        this.props.handleClose();
    };
    onUpdateText = (name, value) => this.setState((prevState) => ({ theme: { ...prevState.theme, [name]: value } }));
    onSubmit = async () => {
        this.setState({ isLoading: true });
        try {
            await saveThemes(this.state.companyId, this.state.theme.name, this.state.theme.themeJson);
            addNotification({ status: "success", message: "Successfully added theme" });
            this.onHandleClose();
        } catch (error) {
            this.setState({ isLoading: false });
            addNotification({ status: "fail", message: "Could not add theme" });
        }
        console.log(this.state.theme);
    };
    render() {
        const { isLoading, theme } = this.state;
        return <Modal show={this.props.isShow} onHide={this.onHandleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Theme Designer</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {isLoading ? <Loader /> :
                    <ThemeDesigner themeChanger={this.onUpdateText} themeName={theme.name} themeJson={theme.themeJson} />
                }
            </Modal.Body>
            <Modal.Footer>
                <Button disabled={isLoading} variant="danger" onClick={this.onHandleClose}>Cancel</Button>
                <Button disabled={isLoading} variant="success" onClick={this.onSubmit}>Submit Theme</Button>
            </Modal.Footer>
        </Modal>;
    }
}


// WEBPACK FOOTER //
// ./src/components/themeDesigner/ThemeDesignerModal.js